import { Reservation } from '@app/models/micro/reservation.model';

export function isHiddenStopReservation(reservation: Reservation): boolean {
  return getHiddenStopDepartureDate(reservation) !== undefined;
}

export function getHiddenStopDepartureDate(reservation: Reservation): string | undefined {
  const segments = reservation?.flightSummary?.segments ?? [];

  for (const segment of segments) {
    const date = segment?.hiddenStop?.departureDateTime;
    if (typeof date === 'string' && date.length > 0) {
      return date.split('T')[0];
    }
  }

  return undefined;
}
